/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable camelcase */

import { PaymentMethodsCommandNames, sendRioEvent, SpecType, SubType, ValidationManager } from '@chegg/commerce-utils';
var getMopError = ValidationManager.ValidationMessages.getMopError;
import { Component } from '../../../constants/CallbackConstants';
import { StatusTypes } from '@chegg/commerce-utils';
import { doFireStatusUpdate, sendRioEventCallback } from '../../../utils/CallbackUtils';
import { updateMOPError } from '../PaymentState.actions';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
/**
 * handleCreateMopError handles errors from create mop API
 */

export var handleUpdateMopError = function handleUpdateMopError(params) {
  var response = params.response,
    dispatch = params.dispatch,
    rioNamespace = params.rioNamespace;
  var _ref = response.data,
    errors2 = _ref.errors2;
  if (errors2 !== null) {
    var _errors2$ = errors2[0],
      code = _errors2$.code,
      message = _errors2$.message;
    var _getMopError = getMopError(code),
      message_id = _getMopError.message_id,
      message_name = _getMopError.message_name,
      message_detail = _getMopError.message_detail;
    var rioMessage = message || message_detail;
    sendNewRelicMessage("UpdateMopLogic: ".concat(JSON.stringify(errors2)));
    doFireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
      payload: {
        component: Component.PAYMENT_MODULE_LOGIC,
        errors: errors2,
        data: response.data
      }
    }]);
    // log an error
    dispatch(updateMOPError({
      message: {
        text: message_detail,
        type: StatusTypes.ERROR,
        code: message_id
      },
      rawData: response.data
    }));

    // update is only applicable to credit cards for now.
    sendRioEvent({
      info: message_name,
      specType: SpecType.NOTIFICATION,
      subType: SubType.ERROR,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      message_detail: "Credit Card: ".concat(rioMessage),
      message_id: message_id
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/helpers/handleUpdateMopError.js
// module id = 4399
// module chunks = 11